import React, { useContext } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import { CommunityListCardHeader, CommunityListCardDetails } from "../common";

const CommunityListCard = ({ details, setSelectedCommunity }: any) => {
  const { dispatch } = useContext(DispatchContext);

  const handleClickCommunity = () => {
    setSelectedCommunity(details);
    dispatch({ type: "POP_UP_OPEN", id: "COMUNITY_DTL_POP", open: { comunityDtlPop: true } });
  };

  const handleClickComment = () => {
    setSelectedCommunity(details);
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMUNITY_DTL_POP",
      open: { comunityDtlPop: true, goToCommentSection: true },
    });
  };

  return (
    <div className="comunity-content" onClick={handleClickCommunity}>
      <CommunityListCardHeader details={details} setSelectedCommunity={setSelectedCommunity} />
      <CommunityListCardDetails details={details} handleClickComment={handleClickComment} />
    </div>
  );
};

export default CommunityListCard;
